export default {
  title: "Potřebuješ pomoc?",
  message: "Napiš nám na <a href=\"mailto:podpora{'@'}provocator.ai\">podpora{'@'}provocator.ai</a> a my se ti ozveme co nejdříve to půjde. Nezapomeň co nejpodrobněji popsat svůj problém, včetně screenshotů, konkrétní URL a dalších nutných informací.",
  copyUrl: "Kopírovat aktuální URL",
  urlCopied: "URL bylo zkopírováno",
};
